import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useProducts } from "../context/ProductContext";
import { BASE_URL, IMG_URL } from "../config/config";
import ProductDetailsModal from "../components/ProductDetails/ProductDetailsModal";
import { toast } from "react-toastify";
import axios from "axios";

const SearchPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  // const { products } = useProducts();
   const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
   const navigate = useNavigate(); 
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("q");
  const handleQuickView = (e, product) => {
    e.preventDefault();
    setSelectedProduct(product);
    setShowModal(true);
  };

 
  useEffect(() => {

     if (!query || query.trim().length < 2) {
      navigate("/"); 
      return;
    }
    const fetchResults = async () => {
      try {
        setLoading(true);
        const res = await axios.post(
          `${BASE_URL}/search_products?q=${encodeURIComponent(query)}`
        );
        setResults(res.data.data || []);
      } catch (err) {
        toast.error("Something went wrong while searching.");
      } finally {
        setLoading(false);
      }
    };
    if (query?.trim().length >= 2) {
      fetchResults();
    } else {
      setResults([]);
    }
  }, [query]);

  return (
    <section className="bg-light py-5">
      <div className="container">
        <div className="mb-4">
          <h3 className="h3 text-dark">Search Products</h3>
        
        </div>

        <div className="row g-4">
          {results.length > 0 ? (
            results.map((product) => (
              <div
                key={product.id}
                className="col-12 col-sm-6 col-md-4 col-lg-3"
              >
                <div className="product-card position-relative overflow-hidden">
                  <div className="product-img-wrapper">
                    <img
                      src={`${IMG_URL}/uploads/${product.image}`}
                      className="img-fluid w-100"
                      alt={product.product_name}
                      style={{ height: "330px" }}
                    />
                    <a
                      href="#"
                      className="quick-view-btn btn btn-light"
                      onClick={(e) => handleQuickView(e, product)}
                    >
                      Quick View
                    </a>
                  </div>

                  <div className="d-flex justify-content-between align-items-start pt-3 px-1">
                    <div>
                      <a
                        href="#"
                        className="text-decoration-none text-muted d-block fw-medium"
                      >
                        {product.product_name}
                      </a>
                      <span className="text-muted">
                        ₹
                      {(() => {
                            try {
                              const rates = product.final_rate
                                ? JSON.parse(product.final_rate)
                                : [];
                              if (Array.isArray(rates) && rates.length) {
                                return (
                                  rates[0].finalRate ||
                                  rates[0].finalAmount ||
                                  "N/A"
                                );
                              } else {
                                return "N/A";
                              }
                            } catch {
                              return "N/A";
                            }
                          })()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-muted">No matching products found.</p>
          )}
        </div>

        <div className="d-flex justify-content-center w-100 pt-4">
          <Link to="/shop">
            <button className="text-uppercase text-white px-4 py-2 border border-dark bg-dark hover-effect">
              Back to Shop
            </button>
          </Link>
        </div>
      </div>

      <ProductDetailsModal
        show={showModal}
        onClose={() => setShowModal(false)}
        product={selectedProduct}
      />
    </section>
  );
};

export default SearchPage;
